import Backend from 'App/Dataman-Backend';

const { apiUrlNews, apiUrlNewsImages, apiUrlSuffix } = Backend.config;

export const NEWS_APP_SERVICE_HOST = 'https://news-app.winglegroup.com';
export const AI_SCRAPER_SERVICE_HOST = 'https://web-ai-scraper.winglegroup.com';

export const NEWS_PATHS = {
  news: apiUrlNews,
  newsImages: apiUrlNewsImages,
  suffix: apiUrlSuffix,

  appNews: `${NEWS_APP_SERVICE_HOST}/api/news`,
  appNewsLD: `${NEWS_APP_SERVICE_HOST}/api/news.jsonld`,
  appDomainsLD: `${NEWS_APP_SERVICE_HOST}/api/domains.jsonld`,
  appTagsLD: `${NEWS_APP_SERVICE_HOST}/api/tags.jsonld`,

  aiNews: `${AI_SCRAPER_SERVICE_HOST}/api/news`,
  aiPrompts: `${AI_SCRAPER_SERVICE_HOST}/api/prompts`,
  aiPromptsRun: `${AI_SCRAPER_SERVICE_HOST}/api/prompts/run`,
  aiDomains: `${AI_SCRAPER_SERVICE_HOST}/api/domains`,
  aiTags: `${AI_SCRAPER_SERVICE_HOST}/api/tags`,
};
